import React, { Component } from 'react';
import { serverIp, firebaseAuth, toCurrency, logComponentLoad, firebaseStorage } from '../../../../config/constants.js'
import { Divider, Form, Segment, Button, Header, Image } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import FileUploader from 'react-firebase-file-uploader';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class UpdateFabricPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            depositAmount: 0,
            deductAmount: 0,
            newBalance: null,
            reason: '',
            dateString: '',
            fabricDropDown: [],
            fabricName: '',
            projectId: '',
            project: '',
            shirtTypeId: '',
            totalCost: '',
            costPerMeter: '',
            fabricPaymentSourceOptions: [],
            fabricPaymentSource: '',

        }
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        if (this.props.match.params.idfabricPayments) {
            this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
                console.log("elx1 +++++++++:removeListener");
                if (user) {
                    if (user.email) {
                        console.log("addx290 user.email  is:" + user.email);
                        this.setState({
                            user: user
                        })
                        //CHECK ALGOLIA FOR USER
                        checkAdminEmail(user.email, this.setAdminResult)
                    }

                } else {
                    console.log("rlx121 user NOT found");
                    this.setState({
                        authed: false,
                        // loading: false,
                        user: user,
                        uid: user.uid
                    })
                }
            })

        } else {
            alert("id fabric payment NOT SENT")
        }


    }


    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "UpdateFabricPayment");

        this.getSingleFabricPayment();

        getPrintValues("fabricPaymentSource", this.loadOptions);

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

        if (e.target.name == 'meters') {
            this.getTotalCost(e.target.value, this.state.costPerMeter);
        }
    }

      /**
    * HANDLE THE FILE UPLOADING..
    */
       handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }


    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }


    getSingleFabricPayment = () => {
        console.log("entx1 +++++ getSingleFabricPayment - ");

        this.setState({ loading: true });
        console.log("entx122 getSingleFabricPayment");


        // SEND CHECK TO SERVER
        axios.post(serverIp + 'stockPayment/getSingleFabricPayment', {
            apiKey: "raw222",
            idfabricPayments: this.props.match.params.idfabricPayments,
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                // CHECK RECEIPTS
                if (response.data.result && response.data.fabricPayment) {

                    if (response.data.fabricPayment) {
                        console.log("found fabricPayment:" + response.data.fabricPayment.idfabricPayments);

                        this.setState({
                            loading: false,
                            fabricPayment: response.data.fabricPayment,
                            meters: response.data.fabricPayment.meters,
                            fabricPaymentSource: response.data.fabricPayment.paidVia,
                            paymentReference: response.data.fabricPayment.paymentReference,
                            notes: response.data.fabricPayment.notes
                        });

                        //LOAD ITEM LIST
                        // if (this.state.algoliaUser && this.state.algoliaUser.perms.includes("UpdateFabricPayment")) {
                        //     this.getInHouseFabricList();
                        //     //1. GET MAIN CARD OBJECTS FROM ALGOLIA
                        //     getPrintValues("fabricPaymentSource", this.loadOptions);
                        // }

                    } else {
                        alert(" no payment found with id:" + this.props.match.params.idfabricPayments);
                    }


                    //alert("Success:" + response.data.message);

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }

            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })

            });


    }

    loadOptions = (displayTypes) => {
        console.log("shtx18 ++++++ load display Types ");
        console.log("shtx18 deposit_source:" + JSON.stringify(displayTypes, null, 3));
        this.setState({ fabricPaymentSourceOptions: displayTypes })
    }

    sendHome = () => {
        history.push("/dashboard/enterFabricPayment")
    }

    updateFabricPayment = () => {
        console.log("entx1 +++++ enterFabricPayment - ");

        // projectId: '',
        //     enteredBy: this.state.user.email,
        //     meters: '',
        //     projectName: '',
        //     enteredItemNumber: '',
        //     dateSent: '',
        //     shirtTypeId: '',
        //     notes: '',

        if (this.state.meters == '') {
            alert("please enter meters");
        } else if (this.state.fabricPaymentSource == '') {
            alert("please enter how payment was sent");
        }   else {

            this.setState({ loading: true });
            // SEND CHECK TO SERVER
            axios.post(serverIp + 'stockPayment/updateFabricPayment', {
                apiKey: "enterFabricPayment",
                idfabricPayments: this.props.match.params.idfabricPayments,
                enteredBy: this.state.user.email,
                meters: this.state.meters,
                notes: this.state.notes,
                fabricPaymentSource: this.state.fabricPaymentSource,
                paymentReference: this.state.paymentReference,
                imageUrl: this.state.docUrl
            })
                .then((response) => {
                    console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result) {

                        this.setState({
                            loading: false,
                        });

                        alert(response.data.message);
                        this.clearFields();

                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    clearFields = () => {

        this.setState({
            loading: false,
            projectId: '',
            enteredBy: this.state.user.email,
            meters: '',
            project: '',
            projectName: '',
            enteredItemNumber: '',
            dateSent: null,
            shirtTypeId: undefined,
            notes: '',
            totalCost: '',
            fabricPaymentSource: '',
            dateString: '',
            fabricName: ''
        })
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - costPerMeter:" + value.rate);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        if (value.category == 'shirtTypeId') {
            newState['fabricName'] = value.label;
            newState['costPerMeter'] = value.rate;
        }


        //this.setState(newState);
        this.setState(newState);
    }

    getTotalCost = (meters, costPer) => {
        console.log("+++++ getTotalCost");
        console.log("meters:" + meters);
        console.log("costPerMeter:" + costPer);
        let totalCost = meters * costPer;
        console.log("totalCost:" + totalCost);

        this.setState({
            totalCost: totalCost
        })
    }

    render() {

        const totalCostUi = this.state.totalCost != ''
            ? <div><label>Total Cost: {toCurrency(this.state.totalCost)}</label></div>
            : ''

        const uploadedImage = this.state.docUrl
            ? (<Image src={this.state.docUrl} size='large' centered bordered shape='rounded' />)
            : (<p></p>)

        const fileUploadUI = <div>
            <h4>DOCLINK: {this.state.docUrl}</h4>
            <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
            {uploadedImage}
        </div>

        const enterPaymentUi = this.state.fabricPayment
            ? <div>

                <Divider horizontal>{'UPDATE FABRIC PAYMENT'}</Divider>

                <Form size='large' onSubmit={this.updateFabricPayment}>
                    <Segment stacked>

                        <label>Date Payment Was Sent</label>

                        <Header as='h2'>
                            {this.state.fabricPayment.idfabricPayments}
                            <Header.Subheader>
                                ID
    </Header.Subheader>
                        </Header>

                        <Header as='h2'>
                            {this.state.fabricPayment.enteredItemNumber}
                            <Header.Subheader>
                                Item Code
    </Header.Subheader>
                        </Header>

                        <Header as='h2'>
                            {this.state.fabricPayment.meters}
                            <Header.Subheader>
                                meters
    </Header.Subheader>
                        </Header>

                        <Header as='h2'>
                            {toCurrency(this.state.fabricPayment.totalCost)}
                            <Header.Subheader>
                                totalCost
    </Header.Subheader>
                        </Header>

                        <Header as='h2'>
                            {this.state.fabricPayment.paidVia}
                            <Header.Subheader>
                                Payment
    </Header.Subheader>
                        </Header>

                        <Header as='h2'>
                            {this.state.fabricPayment.enteredBy}
                            <Header.Subheader>
                                enteredBy
    </Header.Subheader>
                        </Header>


                        <br />
                        {/* Num. Of Meters*/}
                        <Form.Field>
                            <label>Num. Of Meters</label>
                            <br />
                            {totalCostUi}
                            <Form.Input
                                fluid
                                name={'meters'}
                                value={this.state.meters}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Num. Of Meters'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        <label> How Payment was sent  </label>
                        <Select
                            name="form-field-name"
                            value={this.state.fabricPaymentSource}
                            options={this.state.fabricPaymentSourceOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={true}
                            clearable={false}
                        />

                        <br />
                        {/* notes*/}
                        <Form.Field>
                            <label>Payment Reference</label>
                            <Form.Input
                                fluid
                                name={'paymentReference'}
                                value={this.state.paymentReference}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Payment reference if avail e.g req# or mm trans id'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        {/* notes*/}
                        <Form.Field>
                            <label>notes</label>
                            <Form.Input
                                fluid
                                name={'notes'}
                                value={this.state.notes}
                                icon='add user'
                                iconPosition='left'
                                placeholder='reason'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        {fileUploadUI}

                        <Button color='red' fluid size='large'>UPDATE</Button>
                    </Segment>
                </Form>
                <Button onClick={this.sendHome} color='blue' fluid size='large'>BACK TO LIST</Button>
            </div>
            : ''

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms.includes("UpdateFabricPayment")
            ? <div>

                {/* ENTER PAYMENT AFTER PROJECT ID CHECK */}
                {enterPaymentUi}

            </div>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h1>Enter In House fabric Payment</h1>
                    {wholeUI}

                </div>
        );
    }
}

export default UpdateFabricPayment;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/UpdateFabricPayment.js